import { render } from "./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=4e5b9d61"
import script from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"
export * from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4e5b9d61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e5b9d61', script)) {
    api.reload('4e5b9d61', script)
  }
  
  module.hot.accept("./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=4e5b9d61", () => {
    api.rerender('4e5b9d61', render)
  })

}

script.__file = "resources/js/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue"

export default script